<script lang="ts">
	import { getPostContextStore } from '$lib/components/Post/postContextStore';
	import PostLink from './PostLink.svelte';
	export let target: string;

	const post = getPostContextStore();
</script>

<PostLink {target}>
	<div>
		{$post.context}
	</div>
</PostLink>

<style>
	div {
		max-block-size: calc(3 * 18px);
		inline-size: 100%;
		margin-block: var(--gutterSmaller) var(--gutterSmall);
		padding-inline: var(--gutterMedium);
		overflow: hidden;
		color: var(--hubBodyFontColor);
		font: var(--hubBodyFont);
		font-size: 13px;
		font-weight: 400;
		line-height: 18px;
		vertical-align: baseline;
	}
</style>
